import {
  TableCell,
  Paper,
  Box,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import DataTable, {
  IDataTableRow,
  IHeadCell,
} from "components/Common/DataTable";
import { IZnsTemplateParameter } from "modules/outbound-message/types/znsTemplate";
import { useMemo, useState, useCallback } from "react";
import ZnsTemplateService from "modules/outbound-message/services/znsTemplateService";

const headCells: IHeadCell[] = [
  {
    id: "params",
    numeric: false,
    disablePadding: false,
    label: "Parameters",
  },
  {
    id: "sampleData",
    numeric: false,
    disablePadding: false,
    label: "Sample Data",
  },
  {
    id: "technicalSettings",
    numeric: false,
    disablePadding: false,
    label: "Technical Settings",
  },
];

function TemplateRow(props: IDataTableRow) {
  // Current design not mention isRequired, so we add it for compatibility.
  const isRequired = props.item?.isRequired;
  return (
    props.item && (
      <>
        <TableCell sx={{ fontWeight: "bold" }}>{props.item?.params}</TableCell>
        <TableCell>{props.item?.sampleData}</TableCell>
        <TableCell>
          {props.item?.technicalSettings + (isRequired ? "*" : "")}
        </TableCell>
      </>
    )
  );
}

export const TemplateContentPreview = ({
  parameters,
  templateId,
}: {
  parameters: IZnsTemplateParameter[];
  templateId?: string;
}) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadSample = useCallback(async () => {
    if (!templateId) return;
    setIsDownloading(true);
    try {
      await ZnsTemplateService.downloadSampleData(templateId);
    } finally {
      setIsDownloading(false);
    }
  }, [templateId]);
  const defaultParameters = [
    {
      parameterName: "phone",
      parameterType: "Phone Number",
      maxLength: 100,
      isRequired: true,
    },
  ];

  const allParameters = useMemo(() => {
    if (parameters.length === 0) {
      return [];
    }
    return [...defaultParameters, ...parameters];
  }, [parameters]);
  return (
    <Paper sx={{ width: "100%" }}>
      <Stack spacing={2} p={2}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Box>
            <Typography variant="body1" fontWeight="bold">
              Template Content
            </Typography>
            <Typography variant="body2" color="text.secondary">
              The data in the list must be in the correct column order and
              adhere to the parameters outlined below.
            </Typography>
          </Box>
          <Box>
            <Button
              variant="contained"
              color="primary"
              sx={{ fontSize: 15 }}
              disabled={!templateId || isDownloading}
              onClick={handleDownloadSample}
            >
              {isDownloading ? "DOWNLOADING..." : "DOWNLOAD SAMPLE"}
            </Button>
          </Box>
        </Stack>
        <Box>
          {allParameters.length > 0 ? (
            <DataTable
              headCells={headCells}
              rows={allParameters.map((parameter) => ({
                params: parameter.parameterName,
                sampleData: parameter.parameterName,
                technicalSettings:
                  parameter.parameterType + " (" + parameter.maxLength + ")",
              }))}
              paging={undefined}
              name="ZnsTemplateId"
              hideToolbar={true}
              title={""}
            >
              <TemplateRow />
            </DataTable>
          ) : (
            <Box
              sx={{
                height: "200px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "text.secondary",
              }}
            >
              Select an ZNS Template to view
            </Box>
          )}
        </Box>
      </Stack>
    </Paper>
  );
};
